import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"
import Block from "components/Template/Block"
import React from "react"
import styles from "./styles"

const TwoColumn = ({ children, classes, blocks, event }) => (
  <div className={classes.template}>
    {blocks.map(block => {
      block.template = "twoColumn"
      if (block.name === "Shoutouts") {
        block.name = "ScrollingShoutouts"
      }
      if (block.name === "EventEarnings") {
        const shoutouts = blocks.find(
          x => x.name === "Shoutouts" || x.name === "ScrollingShoutouts"
        )
        if (shoutouts) {
          const joinedSettings = { ...shoutouts.settings, ...block.settings }
          block.settings = joinedSettings
        }
      }
      return (
        <div key={block.id} className={classes[block.id]}>
          <div
            className={classnames({
              [classes.blockContainer]: block.name,
              [classes.blockContainerEmpty]: !block.name
            })}
          >
            <Block block={block} event={event} />
          </div>
        </div>
      )
    })}
  </div>
)

export default withStyles(styles, { withTheme: true })(TwoColumn)



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/TwoColumn/index.jsx